import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      organization: ({ auth: { user } }) => user.organization
    }),
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    can (permissions) {
      let permissionsArray = permissions
      if (typeof permissionsArray === 'string') {
        permissionsArray = permissionsArray.split(',')
      }
      return permissionsArray.some(permission => {
        return this.user.permissions.includes(permission)
      })
    }
  }
}
